import { TranslocoService } from '@ngneat/transloco';
import { ConfirmationService } from 'primeng/api';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToolboxCandidateModel } from 'projects/core/src/lib/models/toolbox-candidate.model';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-toolbox-candidate-results',
  templateUrl: './toolbox-candidate-results.component.html',
  styleUrls: ['./toolbox-candidate-results.component.scss']
})
export class ToolboxCandidateResultsComponent implements OnInit {

  @Input() order: ToolboxCandidateModel = null;
  @Output() updateOrder = new EventEmitter<ToolboxCandidateModel>();

  public sending = false;

  constructor(
    private api: ApiService,
    private ui: UiService,
    private auth: AuthStateService,
    private confirmation: ConfirmationService,
    private transloco: TranslocoService
  ) { }

  ngOnInit(): void {
  }

  onResend(): void {
    if (this.auth.hasRight('admin.toolboxcandidate.edit')) {
      this.confirmation.confirm({
        header: this.transloco.translate('toolbox_candidate_results.resend'),
        message: this.transloco.translate('toolbox_candidate_results.really_resend_message'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.sending = true;
          this.api.resendToolboxReport(this.order.id).subscribe({
            next: (result: any) => {
              this.updateOrder.emit(new ToolboxCandidateModel().deserialize(result.data));
              this.ui.toastSuccess(this.transloco.translate('toolbox_candidate_results.report_successfully_resended'));
            },
            error: (error: any) => {
              this.ui.toastError(this.transloco.translate(error.message));
            }
          }).add(() => {
            this.sending = false;
          });
        }
      });
    }
  }

}
